import { Icon } from "@fluentui/react";
import { Utils } from "./Utils";

export type ModalHeaderProps = {
    title: string;
    onClose: () => void;
}

export default function ModalHeaderView({ title, onClose }: ModalHeaderProps) {
    const width2 = Utils.getColumnWidth(2, 3, 3);
    const width10 = Utils.getColumnWidth(10, 9, 9);

    return <div className="popup popup-header">
        <div className="ms-Grid">
            <div className="ms-Grid-row">
                <div className={width10}><b>{title}</b></div>
                <div className={width2 + " right"}>
                    <Icon
                        iconName="ChromeClose"
                        className="pointer"
                        onClick={onClose}
                    />
                </div>
            </div>
        </div>
    </div>
}